<template>
  <!-- 数字政务·二级页面 -->
  <div style="margin-top: 10px; border-top: 1px solid rgb(125, 243, 164)">
    <div class="block">
      <span class="demonstration">选择月份:</span>
      <el-date-picker
        v-model="months"
        type="month"
        value-format="yyyy-MM"
        @change="getMonth()"
        :clearable="false"
        popper-class="backColor"
        prefix-icon="selecticon"
        align="right"
      >
      </el-date-picker>
    </div>
    <div class="div" ref="logo_font">
      <div class="table_border">
        <div v-show="DataMonth" class="monthBox">
          <p>当月数据未更新</p>
        </div>
        <table
          class="table_cont"
          border="1"
          cellpadding="0"
          v-show="!DataMonth"
        >
          <thead>
            <tr
              style="color: #1eeabe; background: #0a4960"
            >
              <td style="width: 10%">乡镇</td>
              <td style="width: 10%">月办件量</td>
              <td style="width: 14%">政务云平台办理量</td>
              <td style="width: 10%">专网办理量</td>
              <td style="width: 14%">政务云平台与专网并行办理量</td>
              <td style="width: 14%">其他方式办理量</td>
              <td style="width: 14%">村级代办量</td>
              <td style="width: 15%">其他途径办理量</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableList" :key="index">
              <td style="width: 10%">{{ item.regionName }}</td>
              <td style="width: 10%">{{ item.caseSum }}</td>
              <td style="width: 14%">{{ item.declare }}</td>
              <td style="width: 10%">{{ item.acceptance }}</td>
              <td style="width: 14%">{{ item.handle }}</td>
              <td style="width: 14%">{{ item.completed }}</td>
              <td style="width: 14%">{{ item.villageHandleNum }}</td>
              <td style="width: 14%">{{ item.otherWayNum }}</td>
            </tr>
            <tr style="color: #55f8ff">
              <td style="width: 10%">合计</td>
              <td style="width: 10%">{{ AcaseSumNum }}</td>
              <td style="width: 14%">{{ AdeclareNum }}</td>
              <td style="width: 10%">{{ AacceptanceNum }}</td>
              <td style="width: 14%">{{ AhandleNum }}</td>
              <td style="width: 14%">{{ AcompletedNum }}</td>
              <td style="width: 14%">{{ AvillageHandleNum }}</td>
              <td style="width: 14%">{{ AotherWayNum }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-center">数据来源：{{ Data_txt }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "digital_government",
  data() {
    return {
      DataMonth: false,
      months: "",
      logo_font: require("@/assets/images/蒙版组 18.png"),
      logo_i: require("@/assets/images/路径 28799.png"),
      tableList: [],
      table_: {},
      Data_txt: "",
      AcaseSumNum: 0,
      AdeclareNum: 0,
      AacceptanceNum: 0,
      AhandleNum: 0,
      AcompletedNum: 0,
      AvillageHandleNum: 0,
      AotherWayNum: 0,
    };
  },
  methods: {
    // 对应月份换数据
    getMonth() {
      this.AcaseSumNum = 0;
      this.AdeclareNum = 0;
      this.AacceptanceNum = 0;
      this.AhandleNum = 0;
      this.AcompletedNum = 0;
      this.AvillageHandleNum = 0;
      this.AotherWayNum = 0;
      var months = plOtherDataInterface.getGovernmentNumberByYearMonth(
        this.months
      );
      months.forEach((item, index) => {
        this.AcaseSumNum += parseInt(item.caseSum);
        this.AdeclareNum += parseInt(item.declare);
        this.AacceptanceNum += parseInt(item.acceptance);
        this.AhandleNum += parseInt(item.handle);
        this.AcompletedNum += parseInt(item.completed);
        this.AvillageHandleNum += parseInt(item.villageHandleNum);
        this.AotherWayNum += parseInt(item.otherWayNum);
      });

      // 为空显示暂无数据
      if (months.length == 0) {
        this.DataMonth = true;
      } else {
        this.tableList = months;
        this.DataMonth = false;
      }
    },
    skMonthrangeDefault() {
      let date = new Date().getDate();
      let year = new Date().getFullYear();
      let month = new Date().getMonth();
      
      if (date < 15) {
        month--;
        if (month < 0) {
          month = 11;
          year--;
        }
      }
      
      month = month + 1; // Convert from 0-11 to 1-12
      if (month < 10) {
        month = "0" + month;
      }
      
      this.months = year + "-" + month;
      console.log(this.months);
    },
    // 数据来源
    Sources() {
      var dataSources = this.$json;
      this.Data_txt = dataSources.data[2].NumGovernment;
    },
  },
  mounted() {
    this.skMonthrangeDefault();
    this.getMonth();
    this.Sources();
  },
};
</script>

<style lang="less" scoped>
.div {
  background: #15606e;
}
.logo_img {
  width: 6.25rem;
  height: 1.575rem;
  margin-top: 1.25rem;
}
.logo_icon {
  position: absolute;
  right: 0.625rem;
  top: 1.25rem;
  width: 1.0625rem;
  height: 1.0625rem;
  cursor: pointer;
}
.logo_font {
  padding-bottom: 1.875rem;
  position: relative;
  border-bottom: 1px solid rgb(125, 243, 164);
}
.table_border {
  padding: 20px 20px 5px;
  height: 510px;
}
.border_height {
  padding: 35px 20px 10px;
}
.table {
  background: #0a4960;
  color: rgb(125, 243, 164);
  font-size: 1.2rem;
  width: 100%;
  text-align: center;
  word-break:break-all;
}

table tbody {
    display: block;
    height: 450px;            
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
     display: none;
   }
}

table thead,
tbody tr {
    display: table;
    width: 100%;
}
.table_cont {
  width: 100%;
  border-collapse: collapse;
  color: #fff;
  font-size: 16px;
  border: 1px solid rgba(131,170,190,0.68);
  td {
    padding: 10px 0;
    border: 1px solid rgba(131,170,190,0.68);
  }
}
.table_cont tr {
  text-align: center;
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}

//  ::-webkit-scrollbar {
//      display: none;
//      scrollbar-width: none;
//    }
//   //  ::-webkit-scrollbar {
//   //    width: 0 !important;
//   //    height:0;
//   //  }

.monthBox {
  width: 100%;
  text-align: center;
  p {
    font-size: 30px;
    color: #fff;
  }
}
.demonstration {
  color: #fff;
  font-size: 17px;
}
/deep/.block {
  margin-top: 15px;
  text-align: right;
  padding-right: 25px;
}
/deep/.el-date-editor.el-input {
  width: 130px;
}
/deep/.el-input__inner {
  height: 27px;
  background: #39819a;
  color: #fff;
  border: 1px solid #39819a;
  cursor: pointer;
}
/deep/ .el-input--prefix .el-input__inner {
  padding-left: 22px;
}
/deep/.el-input__icon {
  line-height: 27px;
}
/deep/.el-picker-panel {
  background-color: #15606e !important;
  left: 1111px !important;
}
/deep/.el-month-table td .cell {
  color: #fff !important;
}
/deep/.el-picker-panel__icon-btn,
.el-date-picker__header-label {
  color: #fff !important;
}
.selecticon {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/digital_government/digital_government.vue